
let array1 = [9470190584093,9470328373533,9470266147101];
if (productIds.length) {
  array1 = productIds;
}
//const productLimitIds;
// New array for quantity limits
console.log(productLimitIds)
let arrayLimit = productLimitIds; 
if (productLimitIds.length) {
  arrayLimit = productLimitIds;
}

let totalLimit = 5;
if(totalLimit > 0){
  totalLimit = productLimit;
}

const cartJson = '/cart.js';
const array2 = [];
const isValuePresent = false;
function getCartJson() {
  //console.log('getCartJson - works')
  const cartAlert = `<div class="quick-drawer-banner quick-add_alert">
                        <span class="icon">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 0C12.4062 0 16 3.59375 16 8C16 12.4375 12.4062 16 8 16C3.5625 16 0 12.4375 0 8C0 3.59375 3.5625 0 8 0ZM7.25 4.75V8.75C7.25 9.1875 7.5625 9.5 8 9.5C8.40625 9.5 8.75 9.1875 8.75 8.75V4.75C8.75 4.34375 8.40625 4 8 4C7.5625 4 7.25 4.34375 7.25 4.75ZM8 12.5C8.53125 12.5 8.96875 12.0625 8.96875 11.5312C8.96875 11 8.53125 10.5625 8 10.5625C7.4375 10.5625 7 11 7 11.5312C7 12.0625 7.4375 12.5 8 12.5Z" fill="#00A4FF"/>
                          </svg>
                        </span>
                        <span>Raiven Marketplace Discount Code required at checkout to purchase.</span>
                        <a class="quick_drawer_more" href="#">Learn more</a>
                    </div>`;
  const cartAlertContent = `<div class="learn_more_overlay" style="display:none"></div><div class="learn_more_reservation" style="display:none">
                              <div class="lmr_content_wrap">
                                <div class="lmr_hd">
                                  <h2 class="h5 mb-0">Raiven Marketplace Discount Code</h2>
                                  <span class="lmr_close_btn">
                                    <svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linejoin="round" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="M5 19 19 5M5 5l14 14"></path></svg>
                                  </span>
                                </div>
                                <div class="lmr_content">
                                  <div class="lmr_heighlight" style="display:none">Apply your "Reservation Code" as a Discount Code at Checkout.</div>
                                  
                                  <h3 class="h6">How do I find my Discount Code?</h3>
                                  <ol>
                                    <li>Log in to <a href="http://app.qmerit.com" target="_blank">app.qmerit.com</a></li>
                                    <li>From the <strong>Active</strong> tab, navigate to your <strong>Activities</strong></li>
                                    <li>Click on an activity for a Cybertruck Powershare Promo installation to view the details on the Info tab</li>
                                    <li>Copy your Raiven Marketplace Discount Code</li>
                                    <li>Paste the Code into the "Discount Code" field during checkout, click Apply, and the price will change to $0</li>
                                  </ol>
                                  <h3 class="h6">Get a Raiven Marketplace Discount Code when you join Qmerit</h3>
                                  <p>To participate in the Powershare Promo, you must be a Qmerit Certified Installer or Solutions Partner and completed the Powershare training.</p>
                                  <ul>
                                    <li>If you are not part of the Qmerit Network - <a href="https://qmerit.com/ev-charging-stations-installer-network/" target="_blank">Join Today!</a></li>
                                    <li>If you are part of the Qmerit Network, for training and powershare installation documentation, please visit the <a href="https://resourcecenter.qmerit.com/" target="_blank">Qmerit Resource Center</a>.</li>
                                  </ul>
                                </div>
                              </div>
                            </div>`;
  
  fetch(cartJson).then((res) => {
      return res.json();
    }).then((data) => {
      localStorage.setItem('cart', JSON.stringify(data));
      const items = data.items;
      const array2 = [];
      
      let arrayLimitItemsQty = 0;
    
      for (let i = 0; i < items.length; i++) {
        console.log(items[i].id);
        array2.push(items[i].product_id);
        
        if (arrayLimit.includes(items[i].product_id)) {
          arrayLimitItemsQty += items[i].quantity;
        }
      }
      
      const isValuePresent = array1.some(value => array2.includes(value));
      
      const exceedsLimit = arrayLimitItemsQty >= totalLimit;
      console.log(`Equals or exceeds ${totalLimit} item limit:`, exceedsLimit);
      
      var proId = Number($('[name="product-id"]').val());
      const cartPage = window.location.pathname;
      //console.log(cartPage)
      
      if(cartPage.indexOf('/cart') > -1){
        //proId = Number($('tr[data-product-id]').data('productId'));
        //console.log('this is testing')
      }
      console.log('product id: '+proId);
      
      const remainingAllowance = Math.max(0, totalLimit - arrayLimitItemsQty);
      console.log('Remaining allowance:', remainingAllowance);
      
      arrayLimit.forEach(productId => {
        // Find the current quantity
        let currentProductQty = 0;
        for (let i = 0; i < items.length; i++) {
          if (items[i].product_id === productId) {
            currentProductQty = items[i].quantity;
            break;
          }
        }
        
        const maxAllowed = currentProductQty + remainingAllowance;
        console.log(`Product ${productId} - current: ${currentProductQty}, max allowed: ${maxAllowed}`);
        
        $(`tr[data-product-id="${productId}"] .qty-input__input`).attr({
          'max': maxAllowed,
          'min': 1
        }).removeClass('restict_qty'); // Remove readonly restriction
        
        if (exceedsLimit) {
          $(`tr[data-product-id="${productId}"] .qty-input__input`).attr('readonly', 'readonly').addClass('restict_qty');
          $(`tr[data-product-id="${productId}"] .qty-input button`).addClass('restict_qty_cart');
        } else {
          $(`tr[data-product-id="${productId}"] .qty-input button`).removeClass('restict_qty_cart');
        }
        
      });
    
      if(arrayLimit.indexOf(proId) > -1){
        const remainingAllowance = Math.max(0, totalLimit - arrayLimitItemsQty);
        
        let currentProductQty = 0;
        for (let i = 0; i < items.length; i++) {
          if (items[i].product_id === proId) {
            currentProductQty = items[i].quantity;
            break;
          }
        }
        
        const maxAllowed = remainingAllowance;
        //console.log(`Product page ID ${proId} - current: ${currentProductQty}, max allowed: ${maxAllowed}`);
        
        $('.product-info__add-to-cart .qty-input__input').attr({
          'max': maxAllowed,
          'min': 1
        }).removeClass('restict_qty');
        $('.product-info__add-to-cart .qty-input button').removeClass('restict_btn');
        
        if (exceedsLimit) {
          $('.product-info__add-to-cart .qty-input__input').attr('readonly', 'readonly').addClass('restict_qty');
          $('.product-info__add-to-cart .qty-input button').addClass('restict_btn');
          $('.product-info__add-button button.product-info__add-btn').addClass('restrict_to_cart');
          console.log('items exceeded limit: '+proId);
        } else {
          $('.product-info__add-button button.product-info__add-btn').removeClass('restrict_to_cart');
          console.log('item under limit: '+proId);
        }
        
      }
      
      if(exceedsLimit) {
        arrayLimit.forEach(productId => {
          $(`product-card[data-prod-id="${productId}"] button.product-info__add-btn`).addClass('restrict_to_cart');
        });
      } else {
        arrayLimit.forEach(productId => {
          $(`product-card[data-prod-id="${productId}"] button.product-info__add-btn`).removeClass('restrict_to_cart');
        });
      }
      
      // Show alert: array1 products
      if(isValuePresent){
        const alertLen = $('.quick-drawer-banner').length;
        if(alertLen == 0){
          const arrayLen = array2.length;
          if(arrayLen > 1){
            // Append cart alert to all product rows
            array1.forEach(productId => {
              if (array2.includes(Number(productId))) {
                $(`tr[data-product-id="${productId}"] .cart-item__details`).append($(cartAlert));
              }
            });
          }else{
            if(cartPage.indexOf('/cart') > -1){
              array1.forEach(productId => {
                if (array2.includes(Number(productId))) {
                  $(`tr[data-product-id="${productId}"] .cart-item__details`).append($(cartAlert));
                  
                }
              });
              
            }else{
              $(cartAlert).insertAfter('cart-warning-banner');
            }
          }
          
          $('cart-drawer').append($(cartAlertContent));
          $('body.template-cart').append($(cartAlertContent));
        }
        
      }else{ 
        console.log('No array1 products in cart');
        $('.quick-drawer-banner').hide();
      }
    });
    $(document).on('click','button.restict_qty_cart', function (event) {
      event.preventDefault();
      cartWarningBnr();
    });
    $('.learn_more_reservation').slideUp();
}
function handleAdditionalInfo() {
  const cartJson = '/cart.js';
  
  fetch(cartJson)
    .then((res) => res.json())
    .then((data) => {
      const items = data.items;
      const cartProductIds = items.map(item => item.product_id);
      
      const isAnyArray1ProductInCart = arrayLimit.some(productId => 
        cartProductIds.includes(productId)
      );
      
      const additionalInfoSection = $('.addtional_information');
      const inputFields = $('.addtional_information input[type="text"], #achknowledge_required');
      
      if (isAnyArray1ProductInCart) {
        additionalInfoSection.show();
        inputFields.prop('required', true);
        inputFields.addClass('required');
      } else {
        additionalInfoSection.hide();
        inputFields.prop('required', false);
        inputFields.removeClass('required');
        
        $('.addtional_information input[type="text"]').val('');
        $('#achknowledge_required').prop('checked', false);
      }
    })
    .catch(error => {
      console.error('Error fetching cart data:', error);
    });
}

$(document).ready(function() {
  handleAdditionalInfo();
});

document.addEventListener('on:line-item:change', handleAdditionalInfo);

function cartWarningBnr() {
  $('cart-warning-banner').removeClass('hidden');
  $('cart-warning-banner span.js-warning-message').text(`Maximum of ${totalLimit} Tesla products can be added to your Cart in total.`);
  $('cart-warning-banner .cart_banner').css({'color':'#FF3D00','background':'rgba(255, 61, 0, 0.2)'});
}
setTimeout(function () {
  getCartJson();  
},300)
document.addEventListener('on:line-item:change', (event) => {
  getCartJson();
});
document.addEventListener('on:cart-drawer:after-open', (event) => {
  getCartJson();
  handleAdditionalInfo();
});
document.addEventListener('on:cart-drawer:after-close', (event) => {
  setTimeout(function(){
    getCartJson();
  },500)
});

$(document).on('click','cart-drawer .quick_drawer_more',function (event) {
  event.preventDefault();
  $('.learn_more_overlay').show();
  $('.learn_more_reservation').slideDown();
})
$(document).on('click','cart-drawer .lmr_close_btn, cart-drawer .learn_more_overlay',function (event) {
  event.preventDefault();
  $('.learn_more_overlay').hide();
  $('.learn_more_reservation').slideUp();
});
$(document).on('click','.template-cart .quick_drawer_more',function (event) {
  event.preventDefault();
  $('.learn_more_overlay').show();
  $('.learn_more_reservation').show();
  $('body').addClass('learn_more_active');
})
$(document).on('click','.template-cart .lmr_close_btn, .template-cart .learn_more_overlay',function (event) {
  event.preventDefault();
  $('.learn_more_overlay').hide();
  $('.learn_more_reservation').hide();
  $('body').removeClass('learn_more_active');
});

$(document).on('click','button.product-info__add-btn.restrict_to_cart', function (event) {
  event.preventDefault();
  const cartDrawer = document.querySelector('cart-drawer');
  cartDrawer.open();
  cartWarningBnr();
  
})

$('span.close_btn').click(function () {
  $('.cart-alert-top').slideUp();
})
//a[data-discount]
$(document).on('click','a.discount-remove',function (event) {
  event.preventDefault();
  clearDiscount();
  
});

function clearDiscount() {
  //clearLocalStorage();
  fetch("/discount/CLEAR").then(function(response) {
      console.log(response);
      
    });
  setTimeout(function () {
    $('a.discount-remove + a.js-remove-item')[0].click()
    console.log('this is done');
  },500)
}

function clearLocalStorage() {
  localStorage.removeItem("discountCode");
}

//Custom Discount code